import React, { useState } from 'react'
import './ConfirmModal.scss'
import { CButton, CModal, CModalBody, CModalFooter, CModalHeader } from '@coreui/react-pro'
import PropTypes from 'prop-types'

export default function Void({ visible, onClose, onVoid, hasNote = false }) {
  const [isClicked, setIsClicked] = useState(false)

  return (
    <CModal
      className="confirm-modal"
      visible={visible}
      onClose={onClose}
      fullscreen="lg"
      alignment={'center'}
    >
      <CModalHeader className="d-flex">
        {hasNote ? 'Download Progress Note Before Deleting?' : 'Are you sure?'}
      </CModalHeader>
      <CModalBody>
        <div style={{ textAlign: 'center' }}>
          {hasNote
            ? 'There is a progress note attached to this encounter.  Progress notes are deleted when encounters are voided.  Would you like to download the progress note first before it is deleted?'
            : 'Encounter and any progress note will be deleted.'}
        </div>
      </CModalBody>
      <CModalFooter>
        {hasNote ? (
          <CButton
            color="primary"
            onClick={() => {
              if (!isClicked) {
                setIsClicked(true)
                onVoid(false)
              }
            }}
          >
            Delete Note
          </CButton>
        ) : (
          <CButton color="secondary" onClick={onClose}>
            Cancel
          </CButton>
        )}
        <CButton
          color="primary"
          onClick={() => {
            if (!isClicked) {
              setIsClicked(true)
              onVoid(true)
            }
          }}
        >
          {hasNote ? 'Download note' : 'Confirm'}
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

Void.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  onVoid: PropTypes.func,
}
